import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { supportApi as r } from "@maat/api-main";
//#region src/support/admin/useAdminUpdateCallbackMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, payload: t }) => r.adminUpdateCallback(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.callbacks() }), i.invalidateQueries({ queryKey: e.callbackStats() });
		}
	});
};
//#endregion
export { i as useAdminUpdateCallbackMutation };
